import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { SEO } from 'components/SEO';

export const TermsOfService: React.FC = () => {
  return (
    <Container className="py-5">
      <SEO 
        title="Terms of Service - Speak on Steem" 
        description="Terms of service for using the Speak on Steem platform."
      />
      <Row className="justify-content-center">
        <Col md={10} lg={8}>
          <div className="legal-content card item-speem p-4">
            <h1 className="mb-4">Terms of Service</h1>
            <p className="text-muted">Last Updated: April 19, 2026</p>

            <section className="mb-4">
              <h2>1. Acceptance of Terms</h2>
              <p>
                By accessing or using Speak on Steem, you agree to be bound by these Terms of Service. If you do not agree to these terms, 
                please do not use our services.
              </p>
            </section>

            <section className="mb-4">
              <h2>2. Description of Service</h2>
              <p>
                Speak on Steem is a decentralized video platform built on the Steem Blockchain. Users can post, view, and interact with video content. 
                Ownership and responsibility for the content remain with the users who post it.
              </p>
            </section>

            <section className="mb-4">
              <h2>3. User Responsibilities</h2>
              <p>
                You are responsible for your own account security and for any content you post. You agree not to:
              </p>
              <ul>
                <li>Post illegal or infringing content.</li>
                <li>Abuse the platform's voting or reward systems.</li>
                <li>Attempt to disrupt the platform's operation.</li>
              </ul>
            </section>

            <section className="mb-4">
              <h2>4. Decentralization and Immutability</h2>
              <p>
                You acknowledge that Speak on Steem interacts with a decentralized blockchain. Transactions once confirmed are immutable. 
                We cannot delete or modify content once it is published to the Steem Blockchain.
              </p>
            </section>

            <section className="mb-4">
              <h2>5. Disclaimer of Warranties</h2>
              <p>
                THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE." WE DISCLAIM ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, 
                INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
              </p>
            </section>

            <section className="mb-4">
              <h2>6. Limitation of Liability</h2>
              <p>
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, SPEAK ON STEEM SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, 
                CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES.
              </p>
            </section>

            <section className="mb-4">
              <h2>7. Contact</h2>
              <p>
                For any questions regarding these terms, please contact us at: <strong>speakonsteem@gmail.com</strong>
              </p>
            </section>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
